<script>
import { Bar } from "vue-chartjs";
export default {
    name: "bar-chart",
    extends: Bar,
    props: {
        chartData: Object,
        options: {
            type: Object,
            default: () => ({}),
        },
    },
    mounted() {
        this.renderChart(this.chartData, this.options);
    },
};
</script>
